import React from 'react'
import Body from './Body';

const Events = () => {
  const _this = {};
  return <Body {..._this} />;
}

export default Events